.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.transport {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.cursor {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.issues {
  margin: 0;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-warning-light);
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body2-fontSize);
  list-style: none;
}

.keyboard {
  width: 100%;
}
